const CONTACT_FORM_USER_TYPE = 'contactFormUserType';
const CONTACT_FORM_CANDIDATE_EMAIL = 'contactFormCandidateEmail';
const CONTACT_FORM_CANDIDATE_DETAILS = 'contactFormCandidateDetails';
const CONTACT_FORM_EMPLOYER_EMAIL = 'contactFormEmployerEmail';
const CONTACT_FORM_EMPLOYER_DETAILS = 'contactFormEmployerDetails';
const CONTACT_FORM_BRANCH_SELECT = 'contactFormBranchSelect';
const CONTACT_FORM_EMAIL_SUCCESS = 'contactFormEmailSuccess';
const CONTACT_FORM_TELFAX_SUCCESS = 'contactFormTelfaxSuccess';
const CONTACT_FORM_WEBSITE_SUCCESS = 'contactFormWebsiteSuccess';
const CONTACT_FORM_SOCIAL_SUCCESS = 'contactFormSocialSuccess';
const CONTACT_CHOOSE_OTHER_OPTION = 'contactChooseOtherOption';

const STAGE_1_VIEW = [CONTACT_FORM_USER_TYPE];

const STAGE_2_VIEW = [CONTACT_FORM_BRANCH_SELECT];

const STAGE_3_VIEW = [
  CONTACT_FORM_CANDIDATE_EMAIL,
  CONTACT_FORM_CANDIDATE_DETAILS,
  CONTACT_FORM_EMPLOYER_EMAIL,
  CONTACT_FORM_EMPLOYER_DETAILS,
];

const CONTACT_FORM_TYPES = {
  contactFormCandidateEmail: 'EmailCandidate',
  contactFormCandidateDetails: 'CandidateInformation',
  contactFormEmployerDetails: 'EmployerInformation',
  contactFormEmployerEmail: 'EmailEmployerCallback',
  contactFormSocialSuccess: 'CandidateInformation',
};

const CONTACT_FORM_FOR_USER = {
    emp: {
        contactFormBranchSelect: 'EmployerInformation',
        contactFormEmailSuccess: 'EmployerInformation',
        contactFormWebsiteSuccess: 'EmployerInformation',
        contactFormTelfaxSuccess: 'EmployerInformation'
    },
    cnd: {
        contactFormBranchSelect: 'CandidateInformation',
        contactFormEmailSuccess: 'CandidateInformation',
        contactFormWebsiteSuccess: 'CandidateInformation',
        contactFormTelfaxSuccess: 'CandidateInformation'
    }
}

export default class {
  static get CONTACT_FORM_USER_TYPE() {
    return CONTACT_FORM_USER_TYPE;
  }

  static get CONTACT_FORM_CANDIDATE_EMAIL() {
    return CONTACT_FORM_CANDIDATE_EMAIL;
  }

  static get CONTACT_FORM_CANDIDATE_DETAILS() {
    return CONTACT_FORM_CANDIDATE_DETAILS;
  }

  static get CONTACT_FORM_EMPLOYER_EMAIL() {
    return CONTACT_FORM_EMPLOYER_EMAIL;
  }

  static get CONTACT_FORM_EMPLOYER_DETAILS() {
    return CONTACT_FORM_EMPLOYER_DETAILS;
  }

  static get CONTACT_FORM_BRANCH_SELECT() {
    return CONTACT_FORM_BRANCH_SELECT;
  }

  static get CONTACT_FORM_EMAIL_SUCCESS() {
    return CONTACT_FORM_EMAIL_SUCCESS;
  }

  static get CONTACT_FORM_TELFAX_SUCCESS() {
    return CONTACT_FORM_TELFAX_SUCCESS;
  }

  static get CONTACT_FORM_WEBSITE_SUCCESS() {
    return CONTACT_FORM_WEBSITE_SUCCESS;
  }

  static get CONTACT_FORM_SOCIAL_SUCCESS() {
    return CONTACT_FORM_SOCIAL_SUCCESS;
  }

  static get STAGE_1_VIEW() {
    return STAGE_1_VIEW;
  }

  static get STAGE_2_VIEW() {
    return STAGE_2_VIEW;
  }

  static get STAGE_3_VIEW() {
    return STAGE_3_VIEW;
  }

  static get CONTACT_FORM_TYPES() {
    return CONTACT_FORM_TYPES;
  }

  static get CONTACT_FORM_FOR_EMP() {
    return CONTACT_FORM_FOR_USER['emp'];
  }

  static get CONTACT_FORM_FOR_CND() {
    return CONTACT_FORM_FOR_USER['cnd'];
  }

  static get CONTACT_CHOOSE_OTHER_OPTION() {
    return CONTACT_CHOOSE_OTHER_OPTION;
  }
}
